"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateReservePriceResponseDto = instanceOfUpdateReservePriceResponseDto;
exports.UpdateReservePriceResponseDtoFromJSON = UpdateReservePriceResponseDtoFromJSON;
exports.UpdateReservePriceResponseDtoFromJSONTyped = UpdateReservePriceResponseDtoFromJSONTyped;
exports.UpdateReservePriceResponseDtoToJSON = UpdateReservePriceResponseDtoToJSON;
exports.UpdateReservePriceResponseDtoToJSONTyped = UpdateReservePriceResponseDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateReservePriceResponseDto interface.
 */
function instanceOfUpdateReservePriceResponseDto(value) {
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('reservePrice' in value) || value['reservePrice'] === undefined)
        return false;
    return true;
}
function UpdateReservePriceResponseDtoFromJSON(json) {
    return UpdateReservePriceResponseDtoFromJSONTyped(json, false);
}
function UpdateReservePriceResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'listingId': json['listingId'],
        'reservePrice': json['reservePrice'],
    };
}
function UpdateReservePriceResponseDtoToJSON(json) {
    return UpdateReservePriceResponseDtoToJSONTyped(json, false);
}
function UpdateReservePriceResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'listingId': value['listingId'],
        'reservePrice': value['reservePrice'],
    };
}
